export default __webpack_public_path__ + "static/media/img55.91555bf0.jpg";